import { Component, Inject, Vue } from 'vue-property-decorator';

@Component
export default class EntitiesMenu extends Vue {}
